import React from "react";
import { Bar, BarChart, Label, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import styles from './BarChart.module.css';

const CustomLegend = (props) => {
    const { payload } = props;
    return (
        <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
            {payload.map((entry, index) => {
                const { value, color } = entry;
                return (
                    <span
                        key={`item-${index}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '0 10px',
                        }}
                    >
                        <span
                            style={{
                                backgroundColor: color,
                                width: '6px',
                                height: '12px',
                                display: 'inline-block',
                                borderRadius: '2px',
                            }}
                        />
                        <span style={{ color: '#4D4D4F' }}>{value}</span>
                    </span>
                );
            })}
        </div>
    );
};

const CustomTooltip = ({ active, payload, sideTab }) => {
    if (active && payload && payload.length) {
        return (
            <div className={styles.customTooltip}>
                {payload.map((item, index) => {
                    return (
                        <React.Fragment key={index}>
                            <p className={styles.tooltipItem}>
                                <span style={{ fontWeight: 500 }}>DC</span> : {item.payload.DC}
                            </p>
                            <p className={styles.tooltipItem}>
                                <span style={{ fontWeight: 500 }}>Suggested Orders</span> : {sideTab !== 'Tonnes' ? item.value.toFixed(0) : item.value}
                            </p>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
    return null;
};

const SingleBarChart = ({ graphData, sideTab }) => {
    return (
        <ResponsiveContainer width="100%" height={600}>
            <BarChart
                data={graphData}
                layout="vertical"
                barGap={5}
                margin={{
                    top: 10,
                    right: 50,
                    left: 20,
                    bottom: 10,
                }}
            >
                <>
                    <XAxis type="number" domain={[0, 'auto']} tickLine={false} className={styles.BarLabelCBU} axisLine={{ strokeDasharray: "3 3", stroke: "#ccc" }}>
                        <Label value="Suggested Orders" position="insideBottom" offset={-5} className={styles.axisLabel} />
                    </XAxis>
                    <YAxis dataKey="DC" type="category" interval={0} className={styles.BarLabelCBU} tickLine={true} axisLine={{ strokeDasharray: "3 3", stroke: "transparent" }}>
                        <Label value="DC" position="left" offset={-5} className={styles.axisLabel} />
                    </YAxis>
                    <Bar style={{ border: "1px solid #85C2FF" }} dataKey="Suggested Orders" fill="#C2E0FF" stroke="#85C2FF" barSize={15} stackId="a" radius={[0, 3, 3, 0]}></Bar>
                    <Tooltip
                        content={<CustomTooltip sideTab={sideTab}/>}
                        wrapperStyle={{
                            fontSize: '12px',
                            padding: '6px',
                        }}
                    />
                </>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default SingleBarChart;